import { render, staticRenderFns } from "./attendance-item.vue?vue&type=template&id=600529f8"
import script from "./attendance-item.vue?vue&type=script&lang=js"
export * from "./attendance-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports